<nav class="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg rtl">
  <div class="container px-4 mx-auto flex flex-wrap items-center justify-between">
    <div class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
      <div>
        <a [routerLink]="['/']"
          class="text-white text-lg font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap">
          استاد ویزیت
        </a>
      </div>
      <div class="flex">
        <button
          class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
          type="button" (click)="setNavbarOpen()">
          <i class="text-white fas fa-bars"></i>
        </button>
        <!-- <ul class="flex lg:flex-row list-none lg:ml-auto">
          <li class="flex items-center">
            <app-pages-dropdown class="block"></app-pages-dropdown>
          </li>
          <li class="flex items-center">
            <a href="">
              <img class="w-12 rounded-full" src="../../../../assets/img/team-4-470x470.png" alt="">
            </a>
          </li>
        </ul> -->
      </div>
      
    </div>
    <div class="lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none"
      [ngClass]="{ hidden: !navbarOpen, 'block rounded shadow-lg': navbarOpen }" id="example-navbar-warning">
      <ul class="flex flex-col lg:flex-row list-none mx-auto">
        <li class="lg:flex items-center">
          <a class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-lg font-bold"
            href="#">
            خدمات
          </a>
          <a class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-lg font-bold"
            routerLink="doctors-list">
            پزشکان ما
          </a>
          <a class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-lg font-bold"
            routerLink="/blog">
            مجله و اخبار
          </a>
          <a class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-lg font-bold"
            href="#">
            ثبت نام پزشک
          </a>
        </li>
      </ul>
      <ul class="flex flex-col lg:flex-row list-none lg:mx-auto">
        <li class="flex items-center">
          <app-pages-dropdown class="block"></app-pages-dropdown>
        </li>

        <li class="flex items-center">
          <app-user-dropdown class="block"></app-user-dropdown>
        </li>
      </ul>
    </div>
  </div>
</nav>